import React from "react";
import { GeolocateControl } from "react-map-gl";
import { TbCurrentLocation } from "react-icons/tb";

export const HiddenMapGeolocateControl = React.forwardRef((props, ref) => (
  <GeolocateControl
    ref={ref}
    style={{ display: "none" }}
    trackUserLocation={false}
    showUserLocation
    {...props}
  />
));
HiddenMapGeolocateControl.displayName = "HiddenMapGeolocateControl";

export const MapGeolocateButton = ({ controlRef }) => (
  <button
    type="button"
    className="geolocate"
    title="Use my location"
    onClick={() => controlRef.current?.trigger()}
  >
    <TbCurrentLocation className="geolocate-icon" />
  </button>
);
